var _path, _path2, _path3, _path4, _path5, _path6, _g, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2daefd",
    d: "M8,0C3.582,0,0,3.582,0,8s3.582,8,8,8s8-3.582,8-8S12.418,0,8,0L8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#194fc6",
    d: "M3,7H0.069C0.028,7.328,0,7.661,0,8s0.028,0.672,0.069,1H3V7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#194fc6",
    d: "M15.931,7H13v2h2.931C15.972,8.672,16,8.339,16,8S15.972,7.328,15.931,7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#194fc6",
    d: "M9,3V0.069C8.672,0.028,8.339,0,8,0S7.328,0.028,7,0.069V3H9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#194fc6",
    d: "M7,13v2.931C7.328,15.972,7.661,16,8,16s0.672-0.028,1-0.069V13H7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2583ef",
    d: "M8,2c3.308,0,6,2.692,6,6s-2.692,6-6,6s-6-2.692-6-6S4.692,2,8,2 M8,0C3.582,0,0,3.582,0,8 s3.582,8,8,8s8-3.582,8-8S12.418,0,8,0L8,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#194fc6",
    points: "10.667,5.667 10.333,5.333 7,7 5.333,10.333 5.667,10.667 9,9"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8bbd0",
    points: "10.333,5.333 7,7 9,9 10.667,5.667"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.63b24fd5975418415aa0f691deea9112.svg";
export { ForwardRef as ReactComponent };